import React from 'react'
import { Container } from 'react-bootstrap';
import { FaWhatsapp, FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, FaTiktok } from 'react-icons/fa';
import './HomeScreen.css';
import Snow from '../Snow/snow';
import BgVideo from '../../Assets/VTASWEB.mp4';
import PageWrapper from "../PageWrapper";

const HomeScreen = () => {
    return (
        <PageWrapper>
        <div className='home-screen' style={{ position: 'relative' }}>
            {/* Background Video */}
            <video
                className="bg-video"
                autoPlay
                loop
                muted
                playsInline
                style={{ position: 'absolute', zIndex: 0 }}
            >
                <source src={BgVideo} type="video/mp4" />
            </video>
            
            {/* Video Overlay for better text readability */}
            <div className="video-overlay" style={{ position: 'absolute', zIndex: 1 }}></div>
            
            {/* Snow Effect */}
            <div style={{ position: 'relative', zIndex: 10 }}>
                <Snow />
            </div>
             
            {/* Main Content */}
            <Container className="text-center bottom-of-page" style={{ position: 'relative', zIndex: 10 }}>
                <div className='caption' style={{ position: 'relative', zIndex: 10 }}>
                    Excellence in Accounting Services
                    <div className='sub-caption'>
                        Your Trusted Partner for Assurance, Tax, and Business Consulting
                    </div>
                    <div className='icons'>
                        <a href="https://wa.me/+94768376087" target="_blank" rel="noopener noreferrer">
                            <FaWhatsapp className="social-icon social-icon-img" style={{ color: '#25D366' }} />
                        </a>
                        <a href="https://www.facebook.com/share/1FzAjgvddy/" target="_blank" rel="noopener noreferrer">
                            <FaFacebookF className="social-icon social-icon-img" style={{ color: '#1877F2' }} />
                        </a>
                        <a href="https://www.youtube.com/@vtaslk" target="_blank" rel="noopener noreferrer">
                            <FaYoutube className="social-icon social-icon-img" style={{ color: '#FF0000' }} />
                        </a>
                        <a href="https://www.instagram.com/vtas__associates" target="_blank" rel="noopener noreferrer">
                            <FaInstagram className="social-icon social-icon-img" style={{ color: '#E4405F' }} />
                        </a>
                        <a href="https://www.linkedin.com/company/vtaslk/" target="_blank" rel="noopener noreferrer">
                            <FaLinkedinIn className="social-icon social-icon-img" style={{ color: '#0A66C2' }} />
                        </a>
                        <a href="https://www.tiktok.com/@vtasassociates?_t=ZS-8xFkzCfgKqW&_r=1" target="_blank" rel="noopener noreferrer">
                            <FaTiktok className="social-icon social-icon-img" style={{ color: '#cfcfcfff' }} />
                        </a>
                    </div>

                    <div className='button-set'>
                        <button
                            type="button"
                            className="readmore-btn-home"
                            onClick={() => window.open('/files/VTAS Profile.pdf', '_blank', 'noopener,noreferrer')}
                        >
                            Read More
                        </button>
                        <a href="#services" className="services-btn-home">
                            Our Services
                        </a>
                    </div>
                </div>
            </Container>
            
            {/* <div className='message' style={{ position: 'relative', zIndex: 10 }}>
                Now We are in Madampe
            </div>  */}
        </div>
        </PageWrapper>
    )
}

export default HomeScreen;